/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_Q7Inputs */

const en_cad_faq_q7 = /** @type {(inputs: Cad_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is cadcraft.org?`)
};

/**
* | output |
* | --- |
* | "What is cadcraft.org?" |
*
* @param {Cad_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_q7 = /** @type {((inputs?: Cad_Faq_Q7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_Q7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_q7(inputs)
});
export { cad_faq_q7 as "cad.faq.q7" }